import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MessageBoxComponent } from '@sircon/sircon-ui-framework';

@Component({
    selector: 'app-sso-expired',
    templateUrl: './sso-expired.component.html',
    imports: [MessageBoxComponent]
})
export class SsoExpiredComponent implements OnInit {
    message: string;

    constructor(
        private route: ActivatedRoute
    ) {
    }

    ngOnInit() {
        switch (this.route.snapshot.queryParams.accountType) {
            case 'firm':
                this.message = 'You will need to return to CMS G2 and click the Sircon Disclosure Management link to continue.';
                break;
            case 'individual':
                this.message = 'You will need to return to Producer Portal and click the Sircon Disclosure Management link to continue.';
                break;
            case 'carrier':
                this.message = 'You will need to return to Producer Manager and click the Sircon Interactive Reporting link to continue.';
                break;
            default:
                break;
        }
    }
}
